import * as React from 'react';
import { FormItem, getDefaultFormItemOptions, IFormItem } from './form-item';
import { CheckboxField, ICheckboxFieldProps } from 'ui-lib/components/checkboxes';
import { Skeleton } from 'ui-lib/components/loading';
import css from './form-item.css';

export interface ICheckBoxFormItemProps extends IFormItem, Omit<ICheckboxFieldProps, 'label'> {
    loading?: boolean;
}

export const CheckBoxFormItem = (props: ICheckBoxFormItemProps) => {
    const formItemProps = getDefaultFormItemOptions(props);
    const { label, ...formProps } = formItemProps;
    return (
        <FormItem
            code={props.code}
            {...formProps}
            initialValue={props.checked}
            child={
                <Skeleton
                    loading={props.loading}
                    noOfRows={1}
                    title={{ className: css['select-form-item-skeleton-default'] }}
                >
                    <CheckboxField
                        label={props.label}
                        checked={props.checked}
                        disabled={props.disabled}
                        onChange={props.onChange}
                    />
                </Skeleton>
            }
        />
    );
}
